import script from "./PurchaseCancel.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseCancel.vue?vue&type=script&setup=true&lang=js"

export default script